import { render } from "./Leaveapproval.vue?vue&type=template&id=6a70e6ec&scoped=true"
import script from "./Leaveapproval.vue?vue&type=script&lang=js"
export * from "./Leaveapproval.vue?vue&type=script&lang=js"

import "./Leaveapproval.vue?vue&type=style&index=0&id=6a70e6ec&lang=scss&scoped=true"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a70e6ec"]])

export default __exports__